/**
 * This file holds the actions/mutations types
 * For more information about why this is needed
 * check here https://vuex.vuejs.org/guide/mutations.html#using-constants-for-mutation-types
 */

export enum ActionTypesStandardNavigation {
  GET_STANDARD_NAVIGATION = "GET_STANDARD_NAVIGATION",
}

export enum MutationTypesStandardNavigation {
  SET_ACTIVE_COMPONENT_STANDARD_NAVIGATION = "SET_ACTIVE_COMPONENT_STANDARD_NAVIGATION",
  SET_LAST_COMPONENT_SWATCH_APPLIED = 'SET_LAST_COMPONENT_SWATCH_APPLIED',
  SET_PREVIOUS_COMPONENT = 'SET_PREVIOUS_COMPONENT',
  SET_STANDARD_NAVIGATION = "SET_STANDARD_NAVIGATION",
  UPDATE_STANDARD_NAVIGATION = "UPDATE_STANDARD_NAVIGATION",
  UPDATE_MENU_STANDARD_NAVIGATION = "UPDATE_MENU_STANDARD_NAVIGATION",
  IS_STANDARD_MENU_OPEN = "IS_STANDARD_MENU_OPEN",
  IS_PREVIOUS_MENU_STATE_OPEN = "IS_PREVIOUS_MENU_STATE_OPEN"
};
